// Показателите на „По категории".
//
// Водещият е оборотът — категориите и бройките само го обясняват. Затова той
// е `hero`, а другите две кутийки стоят до него в равен ред.

import { useTranslation } from "react-i18next";

import { fmtEuro } from "../../../../utils/currency";
import { formatNumber } from "../../../../components/dataTable";
import { ReportKpiCard } from "../ReportKpiCard";
import { deltaPercent } from "../reportDelta";
import type { CategoriesTotals } from "./categoriesMath";

type Props = {
  totals: CategoriesTotals;
  /** Предходният равен отрязък; `null` = сравнението е изключено. */
  previous: { quantity: number; revenue: number } | null;
  isNarrow: boolean;
};

export const CategoriesKpis = ({ totals, previous, isNarrow }: Props) => {
  const { t } = useTranslation();

  return (
    // Класовете са ЦЕЛИ литерали — Tailwind сканира изходния текст и не вижда
    // име, сглобено с template literal.
    <div
      className={`grid gap-2.5 ${
        isNarrow ? "grid-cols-2" : "grid-cols-2 lg:grid-cols-3"
      }`}
    >
      <ReportKpiCard
        kicker={t("reportsPage.itemsRevenueKicker")}
        value={fmtEuro(totals.revenue)}
        sub={t("reportsPage.itemsRevenueSub")}
        delta={
          previous ? deltaPercent(totals.revenue, previous.revenue) : undefined
        }
        hero
      />

      <ReportKpiCard
        kicker={t("reportsPage.categoriesCountKicker")}
        value={String(totals.categories)}
        sub={t("reportsPage.itemsUniqueSub")}
      />

      <ReportKpiCard
        kicker={t("reportsPage.itemsTableKicker")}
        value={formatNumber(totals.quantity)}
        sub={t("reportsPage.categoriesItemsSub")}
        delta={
          previous
            ? deltaPercent(totals.quantity, previous.quantity)
            : undefined
        }
      />
    </div>
  );
};
